import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/RowsPlusTop.es.js";
const s = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: a }));
s.displayName = "RowsPlusTopIcon";
const c = s;
export {
  c as RowsPlusTop,
  s as RowsPlusTopIcon
};
